import { shippingRequestHttp } from "@/api";
import { BaseService } from "@/api/services/baseService";
import { confirmable } from "@/utils/decorator/confirmable";
import type { Device, DeviceVo, ShipBindDevice } from "@zhihaoscm/entity";
import { VideoPlayerUrl } from "@/config";

export class DeviceService extends BaseService<Device, DeviceVo, unknown, unknown> {
    @confirmable("是否删除，删除后该设备将不再展示")
    public async deleteDevice(id: number) {
        return this.service.delete(`${this.path}/${id}`);
    }

    @confirmable({
        msgs: ["是否禁用", "是否启用"]
    })
    public async enableOrDisable(id: number, status: number | string) {
        const { data } = await this.service.put(`${this.path}/update/${id}/state/${status}`);
        return data;
    }
    /**上线设备 */
    public async online(id: number) {
        const { data } = await this.service.put(`${this.path}/online/${id}`);
        return data;
    }
    public async getVo(id: number | string): Promise<DeviceVo> {
        const { data } = await this.service.get(`${this.path}/vo/${id}`);
        return data;
    }

    /**批量上传 */
    public batchUpload<F = any>(form: F, step: number) {
        return this.service.post(`${this.path}/batch-upload/${step}`, form);
    }

    @confirmable("是否提交，提交后将更新设备绑定", "提示", "已提交", "提交")
    public async bindingDevice(params: ShipBindDevice) {
        await this.service.put(`${this.path}/binding-device`, params);
    }
    public async selectorDevice(params?: { keyword?: string }): Promise<Device[]> {
        const { data } = await this.service.get(`${this.path}/selector`, { params });
        return data;
    }

    // 获取抓拍快照
    public async getCapture(deviceSerial: string): Promise<string> {
        const { data } = await this.service.get(`${this.path}/capture`, {
            params: { deviceSerial }
        });
        return data;
    }

    // 海康云眸取流认证token获取
    public async accountInfo(): Promise<{ appKey: string; token: string }> {
        const { data } = await this.service.get(`${this.path}/account/info`);
        return data;
    }
    public async videoPlay(deviceSerial: string, mode: string, dateRange: string = ""): Promise<string> {
        enum Source {
            ADMIN = "1"
        }
        const { token } = await this.accountInfo();
        return VideoPlayerUrl.replace("{dateRange}", dateRange)
            .replace("{token}", token)
            .replace("{deviceSerial}", deviceSerial)
            .replace("{mode}", mode)
            .replace("{origin}", Source.ADMIN);
    }

    // 根据设备名称或序列号,启用状态 查询设备列表
    // 状态 1启用 0禁用   设备名称 或 序列号
    public async findDevice(params: { keyWord: string; state: number }): Promise<Device[]> {
        const { data } = await this.service.get(`${this.path}/findDevice`, { params });
        return data;
    }

    // 获取标准流播放地址
    public async getStandardPlayUrl(params: {
        /** 设备序列号 */
        deviceSerial: string;
        /** 协议地址的类型，1-播放，2-回放，非必选，默认为1 */
        type?: number;
        /** 开始时间,如果是回放必填 */
        startTime?: string;
        /** 结束时间,如果是回放必填 */
        endTime?: string;
    }): Promise<DeviceVo> {
        const { data } = await this.service.get(`${this.path}/media/video`, {
            params,
            timeout: 30000
        });
        return data;
    }

    // 停止播放
    public async stopPlay(
        serialNo: string,
        params: {
            // 可用值:PLAY,PLAYBACK,DOWNLOAD,BROADCAST,TALK
            type: string;
            // 播放地址ID，对应获取标准流播放地址接口的id
            liveId: string;
        }
    ) {
        return await this.service.put(`${this.path}/stop/${serialNo}?type=${params.type}&liveId=${params.liveId}`);
    }
}

export const deviceService = new DeviceService("/device", shippingRequestHttp.service);
